import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { SettingsSidebar } from "./SettingsSidebar";
import { useCurrentCompany } from "@/hooks/useCurrentCompany";
import { Building2 } from "lucide-react";

export function SettingsLayout({ children }: { children: React.ReactNode }) {
  const { name: companyName, loading: companyLoading } = useCurrentCompany();

  return (
    <SidebarProvider
      defaultWidth={280}
      minWidth={220}
      maxWidth={330}
      style={{ "--sidebar-width-icon": "4rem" } as React.CSSProperties}
    >
      <SettingsSidebar />
      <div className="flex-1 flex flex-col min-w-0 min-h-svh">
        <header className="md:hidden sticky top-0 z-30 flex items-center h-12 px-3 bg-background/95 backdrop-blur border-b">
          <SidebarTrigger />
        </header>
        {!companyLoading && companyName && (
          <div className="sticky top-12 md:top-0 z-20 flex items-center gap-2 border-b bg-background/95 backdrop-blur px-4 py-2 text-sm">
            <Building2 className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span className="text-muted-foreground">Company:</span>
            <span className="truncate font-medium">{companyName}</span>
          </div>
        )}
        <main className="flex-1 min-w-0 bg-background">
          <div className="mx-auto w-full max-w-[1800px]">{children}</div>
        </main>
      </div>
    </SidebarProvider>
  );
}
